<template lang="pug">
  main
    NavBar
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns
          .column.is-half.is-offset-one-quarter.has-text-centered
            h1.title Editar Responsiva &nbsp
              router-link.a.button.is-black.is-rounded(to="/Responsivas")
                i.fas.fa-times
        .columns
          .column.is-3
            TypeaheadUsuario(:options="usuarios" :optionSelect="usuarioSel" v-model="usuarioSel" :isDisabled="isTH_disabled")
          .column.is-7
            .columns
              input#respAll.is-checkradio.is-black(type='radio', value='0' v-model='catResp')
              label.is-size-6(for='respAll') Todos
              input#respC.is-checkradio.is-black(type='radio', value='1' v-model='catResp')
              label.is-size-6(for='respC') Cómputo
              input#respCom.is-checkradio.is-black(type='radio', value='2' v-model='catResp')
              label.is-size-6(for='respCom') Teléfono
              input#respE.is-checkradio.is-black(type='radio', value='3' v-model='catResp')
              label.is-size-6(for='respE') Comb.
              input#respT.is-checkradio.is-black(type='radio', value='4' v-model='catResp')
              label.is-size-6(for='respT') Peaje
              input#respV.is-checkradio.is-black(type='radio', value='5' v-model='catResp')
              label.is-size-6(for='respV') Vehículos
          .column.is-2
            .field
              .control
                flat-pickr(
                  v-model='fechaResp'
                  :config="config"
                  class="input"
                )
        .columns
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Artículos asignados&nbsp
                  span.tag.is-black(v-if="Object.keys(itemsSeleccionados).length > 0")
                    | {{ `Seleccionados: ${itemsSeleccionados.length }` }}
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  .column.is-8
                    TbItems_Responsiva(:articulos="items_Responsiva_show" :itemsSel="itemsSeleccionados" :disabledItems="isDisabled" @seleccionarItem="seleccionarItem" :reset="resetarList")
                  .column.is-4
                    
        .columns(v-show="verForm>=1")
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Registro Responsiva&nbsp
                  span(v-html="getTitleDatosForms()")
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  FormComputo_Edit(:desHabilitar="desabilitarForms" :item="itemsSeleccionados.length > 0 ? itemsSeleccionados[0] : {}" :dataBD="dataFormComputoBD" @closeForm="checkFormComputo" v-show="verForm==1")
                  FormTelefono_Edit(:desHabilitar="desabilitarForms" :item="dataFormTelefonoBD" @closeForm="checkFormTelefono" v-show="verForm==2")
                  FormCombustible_Edit(:desHabilitar="desabilitarForms" :dataBD="dataFormCombustibleBD" @closeForm="checkFormCombustible" v-show="verForm==3")
                  FormPeaje_Edit(:desHabilitar="desabilitarForms" :dataBD="dataFormPeajeBD" @closeForm="checkFormPeaje" v-show="verForm==4")
                  FormVehiculo_Edit(:desHabilitar="desabilitarForms" :dataBD="dataFormVehiculoBD" :item="itemsSeleccionados.length > 0 ? itemsSeleccionados[0] : {}" @closeForm="checkFormVehiculo" @updateFormVehiculo='updateFormVehiculo' v-show="verForm==5")
        .columns(v-show="verForm==1 || verForm==2 || verForm==5")
          .column.is-12
            bulma-accordion
              bulma-accordion-item
                p.title.is-4.has-text-weight-normal(slot='title')
                  | Items para inventario&nbsp
                  span(v-html="getTitleDatosList()")
                i.material-icons(slot='icon') more_vert
                .high(slot='content')
                  Listitems_Computo_Edit(:dataItemsBd="dataFormComputoBD" :desHabilitar="deshabilitarCheck_items" @itemsSelected_Comp="itemsSelected_Comp" v-show="verForm==1")
                  ListItems_Telefono_Edit(:dataItemsBd="dataFormTelefonoBD" :desHabilitar="deshabilitarCheck_items" @itemsSelected_Tel="itemsSelected_Tel" v-show="verForm==2")
                  ListItems_Vehiculo_Edit(:dataBD="dataFormVehiculoBD" :desHabilitar="deshabilitarCheck_items" :polizas="polizas" @itemsSelected_Vehiculo="itemsSelected_Vehiculo" v-show="verForm==5")
        .columns.has-text-centered
          .column.is-offset-3.is-6
            a.button(@click="updateResponsiva" :disabled="!activarGuardar" :class="claseButton" )
              | Actualizar Responsiva
            | &nbsp
            router-link.a.button(to="/Responsivas")
              | Regresar
        .columns.column-blanco
    
</template>

<script>
import Loader from "../shared/Loader.vue"
import NavBar from "./shared/NavBar.vue"
import TypeaheadUsuario from "../../components/usuarios_Componentes/componentes/TypeaheadUsuario.vue"
import moment from "moment"
import TbItems_Responsiva from "./components/TbItems_Responsiva.vue"
import FormComputo_Edit from "./components/FormComputo_Edit.vue"
import FormCombustible_Edit from "./components/FormCombustible_Edit.vue"
import FormTelefono_Edit from "./components/FormTelefono_Edit.vue"
import FormPeaje_Edit from "./components/FormPeaje_Edit.vue"
import FormVehiculo_Edit from "./components/FormVehiculo_Edit.vue"
import Listitems_Computo_Edit from "./components/Listitems_Computo_Edit.vue"
import ListItems_Telefono_Edit from "./components/ListItems_Telefono_Edit.vue"
import ListItems_Vehiculo_Edit from "./components/ListItems_Vehiculo_Edit.vue"

import ResponsivasService from "@/services/inventario/responsivas"
import usuariosServices from "../../services/usuarios/usuarios"
import { BulmaAccordion, BulmaAccordionItem } from "vue-bulma-accordion"
import flatPickr from "vue-flatpickr-component"
import "flatpickr/dist/flatpickr.css"
import { Spanish } from "flatpickr/dist/l10n/es.js"
import { mapState } from "vuex"

export default {
  name: "EditarResponsiva",
  components: {
    Loader,
    NavBar,
    TypeaheadUsuario,
    TbItems_Responsiva,
    BulmaAccordion,
    BulmaAccordionItem,
    FormComputo_Edit,
    FormCombustible_Edit,
    FormTelefono_Edit,
    FormPeaje_Edit,
    FormVehiculo_Edit,
    Listitems_Computo_Edit,
    ListItems_Telefono_Edit,
    ListItems_Vehiculo_Edit,
    flatPickr
  },
  data() {
    return {
      isLoading: true,
      usuarios: [],
      usuarioSel: {},
      isTH_disabled: false,
      catResp: "0",
      resetarList: false,
      ver_NoUser: false,
      items_Responsiva: [],
      items_Responsiva_show: [],
      isDisabled: false,
      claseButton: "is-black",
      itemsSeleccionados: [],
      itemBD: {},
      formCompleto: false,
      activarGuardar: true,
      dataFormComputo: {},
      dataFormCombustible: {},
      dataFormTelefono: {},
      dataFormPeaje: {},
      dataFormVehiculo: {},
      dataFormComputoBD: {},
      dataFormCombustibleBD: {},
      dataFormTelefonoBD: {},
      dataFormPeajeBD: {},
      dataFormVehiculoBD: {},
      itemsComputo: [],
      itemsTelefono: [],
      itemsVehiculo: [],
      verForm: 0,
      deshabilitarCheck_items: false,
      desabilitarForms: false,
      fechaResp: null,
      config: {
        wrap: true, // set wrap to true only when using 'input-group'
        altFormat: "Y-m-d",
        altInput: true,
        dateFormat: "Y-m-d",
        locale: Spanish // locale for this instance only
      },
      fechaI: moment(this.fechaResp)
        .startOf("month")
        .format("YYYY-MM-DD"),
      fechaF: moment(this.fechaResp)
        .endOf("month")
        .format("YYYY-MM-DD"),
      isEditing: false,
      isMultiple: false,
      itemsBD: [],
      itemsGuardados: 0,
      updFormVehiculo: false,
      polizas: [],
    }
  },
  watch: {
    catResp () {
      if (this.catResp === '0') {
        this.items_Responsiva_show = this.items_Responsiva
      } else {
        this.items_Responsiva_show = this.items_Responsiva.filter( art => art.responsiva === parseInt(this.catResp))
      }
      this.verForm = parseInt(this.catResp)
    },

    usuarioSel() {
      console.log('usuario sel')
      this.isLoading = true
      this.items_Responsiva = []
      this.items_Responsiva_show = []
      this.itemsSeleccionados = []
      this.getArticulos_asignados()
    },

    formCompleto() {
      console.log(`FormCompleto ${this.formCompleto}`)
      if (this.formCompleto) {
        this.activarGuardar = true
        this.claseButton = 'is-black'
      } else {
        this.activarGuardar = false
      }
    },

    itemsSeleccionados() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.isMultiple = false
        this.checkFormularios()
      }
    },

    dataFormComputo() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    dataFormCombustible() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    dataFormTelefono() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    dataFormPeaje() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    dataFormVehiculo() {
      console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    itemsComputo() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    itemsTelefono() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    itemsVehiculo() {
      //console.log(`Items Seleccionados ${this.itemsSeleccionados.length} | 1`)
      if (this.itemsSeleccionados.length > 0) {
          this.activarGuardar = true
          this.claseButton = 'is-black'
          this.itemsSeleccionados.length > 1 ? this.isMultiple = true : this.isMultiple = false
      } else {
        this.claseButton = 'is-ligth'
        this.activarGuardar = false
        this.checkFormularios()
      }
    },

    fechaResp() {
      this.fechaI = moment(this.fechaResp)
        .startOf("month")
        .format("YYYY-MM-DD")
      this.fechaF = moment(this.fechaResp)
        .endOf("month")
        .format("YYYY-MM-DD")
    },
    
    isMultiple() {
      if (this.isMultiple) {
        this.catResp = '0'
        this.verForm = 0
      }
    }
  },
  methods: {
    iniciarComponente() {
      this.itemsSeleccionados = []
      this.fechaResp = moment(this.responsiva_editar.fecha).format('YYYY-MM-DD')
      this.catResp = this.responsiva_editar.categoria.toString()
      
      if (this.responsiva_editar.tipo == 0) {
        this.isMultiple = true
      }
      this.obtenerPolizas()
      this.isDisabled = false
      this.isTH_disabled = false
      this.verForm = parseInt(this.catResp)
      
    },

    obtenerPolizas() {
        ResponsivasService.obtenerPolizas()
          .then( data => {
            this.polizas = data.map(this.convertirPolizas)
            this.obtenerUsuarios()  
          })
          .catch((error) => {
            this.isLoading = false
            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
          })
      },

      convertirPolizas (poliza) {
        return {
          ...poliza,
          id: parseInt(poliza.id),
          cobertura: parseInt(poliza.cobertura),
          coberturaStr: parseInt(poliza.cobertura) == 1 ? 'AMPLIA': 'LIMITADA',
        }
      },

    obtenerUsuarios () {
      usuariosServices.getUsuarios()
        .then( (res) => {
          if (res.length > 0) {
            const usersSort = res.sort((a,b) => (a.nombre > b.nombre) ? 1 : ((b.nombre > a.nombre) ? -1 : 0))
            this.usuarios = usersSort.map(this.convertirDataUsuarios)
            this.isLoading = false
            this.checkUserBD()
          } else {
            this.displayToast('No hay datos', 'ban', 'OK')
            this.isLoading = false
          }  
        })
        .catch((error) => {
          this.isLoading = false
          this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
        })
    },

    checkUserBD () {
      this.usuarioSel = this.usuarios.find( user => user.id === this.responsiva_editar.idUsuario)
    },

    getArticulos_asignados() {
      ResponsivasService.getItemsResponsivas(this.usuarioSel.id)
        .then(data => {
          console.log(data)
          this.items_Responsiva = data.map(this.convetirItemsResponsiva)
          this.items_Responsiva_show = this.items_Responsiva

          if (this.responsiva_editar.id_articulo === 'multiple' && this.responsiva_editar.tipo == 0) {
            this.getItems_ResponsivasBD()
          } else {
            const objectSel = this.items_Responsiva.find(item => item.id === this.responsiva_editar.id_articulo)
            this.itemsSeleccionados.push(this.convetirItemsResponsiva(objectSel))
            this.obtenerData()
          }
        })
        .catch(e => {
          this.isLoading = false
          this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
        })
    },

    getItems_ResponsivasBD () {
      ResponsivasService.getItems_Multiples(this.responsiva_editar.nombre_responsiva)
        .then(data => {
          this.itemsBD = data
          console.log(data)
          this.compareItems()
        })
        .catch(error => {
          this.isLoading = false
          this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
        })
    },

    compareItems () {
      console.log('Compare Items')
      this.itemsBD.map(item => {
        let itemEncontrado = this.items_Responsiva.find( itemR => itemR.id === item.id_articulo)
        console.log(itemEncontrado)
        if (itemEncontrado) {
          this.itemsSeleccionados.push(this.convetirItemsResponsiva(itemEncontrado))
        }
      })
      this.isLoading = false
      this.checkFormularios()
    },

    updateResponsiva () {
      if (this.activarGuardar) {
        this.isLoading = true

        if (this.isMultiple) {
          ResponsivasService.updateResponsiva(this.responsiva_editar.id, this.responsiva_editar.nombre_responsiva, this.fechaResp, this.usuarioSel.id, this.usuarioSel.nombre, this.catResp, this.usuarioSel.ubicacion, this.usuarioSel.departamento, 'multiple', this.usuarioSel.cargo, this.usuarioSel.numEmpleado, 0)
            .then( (data) => {
              if (data.success) {

                // delete items
                ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '0')
                  .then( resp => {
                    if (resp.success) {
                      this.itemsSeleccionados.map( (item) => {
                        //  Agregar los items
                        ResponsivasService.addItems_Multiples(this.responsiva_editar.nombre_responsiva, item.id)
                          .then((res) => {
                            this.itemsGuardados++

                            if (this.itemsSeleccionados.length == this.itemsGuardados) {
                              this.isLoading = false
                              this.displayToast(`Se actualizó la responsiva y ${this.itemsGuardados} artículos han sido actualizados.`, 'done', 'OK')
                              this.$router.push('/Responsivas')
                            } else {
                              console.log(`Items gurdados ${this.itemsGuardados} de ${this.itemsSeleccionados.length}`)
                            }
                          })
                          .catch((error) => {
                            this.isLoading = false
                            this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
                          })
                      })
                    } else {
                      this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'ban', 'OK')
                    }
                  })
                  .catch( e => {
                    this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'ban', 'OK')
                  })
                
              } else {
                this.isLoading = false
                this.displayToast(data.respuesta, 'ban', 'OK')
              }
            })
            .catch((error) => {
              this.isLoading = false
              this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
            })
        } else {
          //const areaResp = parseInt(this.catResp) == 1 ? 3 : 2
          ResponsivasService.updateResponsiva(this.responsiva_editar.id, this.responsiva_editar.nombre_responsiva, this.fechaResp, this.usuarioSel.id, this.usuarioSel.nombre, this.catResp, this.usuarioSel.ubicacion, this.usuarioSel.departamento, this.itemsSeleccionados[0].id, this.usuarioSel.cargo, this.usuarioSel.numEmpleado, 1)
            .then((data) => {
              if (data.success) {
                switch (parseInt(this.catResp)) {
                  case 1:
                    console.log("Entrando a categoria 1")
                    ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '1')
                    .then( resp => {
                      if (resp.success) {
                        ResponsivasService.addItems_Computo(this.responsiva_editar.nombre_responsiva, this.itemsSeleccionados[0].id, this.dataFormComputo.color, this.dataFormComputo.capacidad, this.dataFormComputo.memoria, this.itemsComputo.cargador ? 1 : 0, this.itemsComputo.backpack ? 1 : 0, this.itemsComputo.caja ? 1 : 0, this.itemsComputo.mouse ? 1 : 0, this.itemsComputo.funda ? 1 : 0, this.itemsComputo.accesorios ? 1 : 0)
                          .then( resItems => {
                            console.log(resItems)
                            if (resItems.success) {
                              this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} ha sido actualizada.`, 'done', 'OK')
                              this.$router.push('/Responsivas')
                            } else {
                              this.displayToast(`Error: ${resItems.respuesta}`, 'ban', 'OK')
                            }
                            this.isLoading = false
                          })
                          .catch( (e) => {
                            this.isLoading = false
                            this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                          })
                      } else {
                        this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'done', 'OK')
                      }
                    })
                    .catch( e => {
                        this.isLoading = false
                        this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                      })
                    
                    break
                  case 2:
                    console.log("Entrando a categoria 2")
                    ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '2')
                    .then( resp => {
                      if (resp.success) {
                        ResponsivasService.addItems_Telefono(this.responsiva_editar.nombre_responsiva, this.itemsSeleccionados[0].id, this.dataFormTelefono.modelo, this.dataFormTelefono.capacidad, this.dataFormTelefono.color, this.dataFormTelefono.numero, this.dataFormTelefono.imei, this.dataFormTelefono.serie, this.dataFormTelefono.minutos, this.dataFormTelefono.sms, this.dataFormTelefono.plan, this.itemsTelefono.cargador, this.itemsTelefono.audifonos, this.itemsTelefono.caja, this.itemsTelefono.sim, this.itemsTelefono.protector, this.itemsTelefono.adaptador)
                          .then( resItems => {
                            console.log(resItems)
                            if (resItems.success) {
                              this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} ha sido actualizada.`, 'done', 'OK')
                              this.$router.push('/Responsivas')
                            } else {
                              this.displayToast(`Error: ${resItems.respuesta}`, 'ban', 'OK')
                            }
                            this.isLoading = false
                          })
                          .catch( (e) => {
                            this.isLoading = false
                            this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                          })
                      } else {
                        this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'done', 'OK')
                      }
                    })
                    .catch( e => {
                        this.isLoading = false
                        this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                      })
                    
                    break
                  case 3:
                    console.log("Entrando a categoria 3")
                    ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '3')
                      .then( resp => {
                        if (resp.success) {
                          ResponsivasService.addItems_Combustible(this.responsiva_editar.nombre_responsiva, this.itemsSeleccionados[0].id, this.dataFormCombustible.tarjeta)
                            .then( resItems => {
                              console.log(resItems)
                              if (resItems.success) {
                                this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} ha sido actualizada.`, 'done', 'OK')
                                this.$router.push('/Responsivas')
                              } else {
                                this.displayToast(`Error: ${resItems.respuesta}`, 'ban', 'OK')
                              }
                              this.isLoading = false
                            })
                            .catch( (e) => {
                              this.isLoading = false
                              this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                            })
                        } else {
                          this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'done', 'OK')
                        }
                      })
                      .catch( e => {
                        this.isLoading = false
                        this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                      })
                    
                    break
                  case 4:
                    console.log("Entrando a categoria 4")
                    ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '4')
                      .then( resp => {
                        if (resp.success) {
                          ResponsivasService.addItems_Peaje(this.responsiva_editar.nombre_responsiva, this.itemsSeleccionados[0].id, this.dataFormPeaje.status, this.dataFormPeaje.dispositivo)
                            .then( resItems => {
                              console.log(resItems)
                              if (resItems.success) {
                                this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} ha sido actualizada.`, 'done', 'OK')
                                this.$router.push('/Responsivas')
                              } else {
                                this.displayToast(`Error: ${resItems.respuesta}`, 'ban', 'OK')
                              }
                              this.isLoading = false
                            })
                            .catch( (e) => {
                              this.isLoading = false
                              this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                            })
                        } else {
                          this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'done', 'OK')
                        }
                      })
                      .catch( e => {
                        this.isLoading = false
                        this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                      })
                    
                    break
                  case 5:
                    console.log("Entrando a categoria 5")
                    console.log(this.dataFormVehiculo)
                    
                    ResponsivasService.deleteItems_responsiva(this.responsiva_editar.nombre_responsiva, '5')
                      .then( resp => {
                        if (resp.success) {
                          let myObj = {
                            'idResponsiva': this.responsiva_editar.nombre_responsiva, 
                            'idVehiculo': this.itemsSeleccionados[0].id, 
                            'categoria': this.dataFormVehiculo.categoria, 
                            'year': this.dataFormVehiculo.year ? this.dataFormVehiculo.year : this.dataFormVehiculo.anio_modelo, 
                            'numeroMotor': this.dataFormVehiculo.motor ? this.dataFormVehiculo.motor : this.dataFormVehiculoBD.numero_motor,
                            'color': this.dataFormVehiculo.color, 
                            'placas': this.dataFormVehiculo.placas, 
                            'serie': this.dataFormVehiculo.serie, 
                            'gasolina': this.dataFormVehiculo.gasolina, 
                            'estatus': this.itemsVehiculo.estatus, 
                            'aseguradora': this.itemsVehiculo.aseguradora, 
                            'poliza': this.itemsVehiculo.poliza, 
                            'cobertura': this.itemsVehiculo.cobertura, 
                            'vencimiento': this.itemsVehiculo.vencimiento, 
                            'observaciones': this.itemsVehiculo.observaciones,
                            'antenaRadio': this.itemsVehiculo.antenaRadio,
                            'batea': this.itemsVehiculo.batea,
                            'bedliner': this.itemsVehiculo.bedliner,
                            'birlos': this.itemsVehiculo.birlos,
                            'bolsa': this.itemsVehiculo.bolsa,
                            'cablesCor': this.itemsVehiculo.cablesCor,
                            'calaveras': this.itemsVehiculo.calaveras,
                            'cinturonesSeg': this.itemsVehiculo.cinturonesSeg,
                            'controlApert': this.itemsVehiculo.controlApert,
                            'cristales': this.itemsVehiculo.cristales,
                            'defensas': this.itemsVehiculo.defensas,
                            'emblemaD': this.itemsVehiculo.emblemaD,
                            'emblemaT': this.itemsVehiculo.emblemaT,
                            'encendedor': this.itemsVehiculo.encendedor,
                            'espejoInt': this.itemsVehiculo.espejoInt,
                            'espejoLD': this.itemsVehiculo.espejoLD,
                            'espejoLI': this.itemsVehiculo.espejoLI,
                            'extintor': this.itemsVehiculo.extintor,
                            'faros': this.itemsVehiculo.faros,
                            'hojalateria': this.itemsVehiculo.hojalateria,
                            'gato': this.itemsVehiculo.gato,
                            'limpiadores': this.itemsVehiculo.limpiadores,
                            'llanta': this.itemsVehiculo.llanta,
                            'llantas': this.itemsVehiculo.llantas,
                            'llave': this.itemsVehiculo.llave,
                            'llaveCruz': this.itemsVehiculo.llaveCruz,
                            'llaveTaponComb': this.itemsVehiculo.llaveTaponComb,
                            'manija': this.itemsVehiculo.manija,
                            'manual': this.itemsVehiculo.manual,
                            'medallon': this.itemsVehiculo.medallon,
                            'molduras': this.itemsVehiculo.molduras,
                            'motor': this.itemsVehiculo.motor,
                            'parabrisas': this.itemsVehiculo.parabrisas,
                            'pintura': this.itemsVehiculo.pintura,
                            'placaD': this.itemsVehiculo.placaD,
                            'placaT': this.itemsVehiculo.placaT,
                            'polizaV': this.itemsVehiculo.polizaV,
                            'portaPD': this.itemsVehiculo.portaPD,
                            'portaPT': this.itemsVehiculo.portaPT,
                            'radio': this.itemsVehiculo.radio,
                            'reflejantes': this.itemsVehiculo.reflejantes,
                            'rines': this.itemsVehiculo.rines,
                            'tapaCBatea': this.itemsVehiculo.tapaCBatea,
                            'tapetes': this.itemsVehiculo.tapetes,
                            'taponAceite': this.itemsVehiculo.taponAceite,
                            'taponRueda': this.itemsVehiculo.taponRueda,
                            'taponGas': this.itemsVehiculo.taponGas,
                            'taponRadiador': this.itemsVehiculo.taponRadiador,
                            'tarjetaCirc': this.itemsVehiculo.tarjetaCirc,
                            'varillaAceite': this.itemsVehiculo.varillaAceite,
                            'verificacion': this.itemsVehiculo.verificacion,
                            'vestiduras': this.itemsVehiculo.vestiduras,
                            'viceras': this.itemsVehiculo.viceras,
                          }
                          ResponsivasService.addItems_Vehiculo(myObj)
                            .then( resItems => {
                              console.log(resItems)
                              if (resItems.success) {
                                this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} ha sido actualizada.`, 'done', 'OK')
                                this.$router.push('/Responsivas')
                              } else {
                                this.isLoading = false
                                this.displayToast(`Error: ${resItems.respuesta}`, 'ban', 'OK')
                              }
                              this.isLoading = false
                            })
                            .catch( (e) => {
                              this.isLoading = false
                              this.displayToast(`Error: ${e.message}`, 'ban', 'Ok')
                            })
                        } else {
                          this.displayToast(`La Responsiva ${this.responsiva_editar.nombre_responsiva} No se ha sido actualizar.`, 'done', 'OK')
                        }
                      })
                      .catch( e => {
                        this.isLoading = false
                        this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                      })
                    break
                }
              } else {
                this.isLoading = false
                this.displayToast(`Error ${data.respuesta}`, 'ban', 'OK')
              }
            })
            .catch((error) => {
              this.isLoading = false
              this.displayToast(`Error: ${error.message}`, 'ban', 'OK')
            })


        }
      } else {
        console.log("No hacer nada")
      }
    },

    editar () {
      this.isEditing = true
    },

    cancelEditar () {
      this.isEditing = false
    },

    seleccionarItem (items) {
      if (items) {
        this.itemsSeleccionados = items
      }
    },

    checkFormComputo (obj) {
      if (obj !== "close") {
        this.dataFormComputo = Object.assign({}, this.dataFormComputo, obj)
      }
    },

    checkFormCombustible (obj) {
      if (obj !== "close") {
        this.dataFormCombustible = Object.assign({}, this.dataFormCombustible, obj)
      }
    },

    checkFormTelefono (obj) {
      if (obj !== "close") {
        this.dataFormTelefono = Object.assign({}, this.dataFormTelefono, obj)
      }
    },

    checkFormPeaje (obj) {
      if (obj !== "close") {
        this.dataFormPeaje = Object.assign({}, this.dataFormPeaje, obj)
      }
    },

    checkFormVehiculo (obj) {
      if (obj !== "close") {
        this.dataFormVehiculo = {}
        this.dataFormVehiculo = Object.assign({}, this.dataFormVehiculo, obj)
      }
    },

    itemsSelected_Comp (obj) {
      console.log(obj)
      if (obj !== "close") {
        this.itemsComputo = Object.assign({}, this.itemsComputo, obj)
      }
    },

    itemsSelected_Tel (obj) {
      if (obj !== "close") {
        this.itemsTelefono = Object.assign({}, this.itemsTelefono, obj)
      }
    },

    itemsSelected_Vehiculo (obj) {
      if (obj !== "close") {
        this.itemsVehiculo = {}
        this.itemsVehiculo = Object.assign({}, this.itemsVehiculo, obj)
      }
    },

    checkFormularios() {
      //console.log("Check Formularios")
      if (this.itemsSeleccionados.length > 0) {
        //console.log("Se ha seleccionado un Item")
        if (
          Object.keys(this.dataFormComputo).length > 0 ||
          Object.keys(this.dataFormCombustible).length > 0 ||
          Object.keys(this.dataFormTelefono).length > 0 ||
          Object.keys(this.dataFormPeaje).length > 0 ||
          Object.keys(this.dataFormVehiculo).length > 0
        ) {
          //console.log("Se ha llenado un formulario")
          //console.log("Falta Checar Items")
          //  Si son cats 4 y 5 no preguntar por items

          switch (parseInt(this.catResp)) {
            case 1:
              if (
                Object.keys(this.itemsComputo).length > 0 ||
                Object.keys(this.itemsTelefono).length > 0 ||
                Object.keys(this.itemsVehiculo).length > 0
              ) {
                console.log("Artículo, Formulario e items completos")
                this.formCompleto = true
              } else {
                console.log("Artículo, Formulario completos, FALTAN ITEMS")
                this.formCompleto = false
              }
              break
            case 2:
              if (
                Object.keys(this.itemsComputo).length > 0 ||
                Object.keys(this.itemsTelefono).length > 0 ||
                Object.keys(this.itemsVehiculo).length > 0
              ) {
                console.log("Artículo, Formulario e items completos")
                this.formCompleto = true
              } else {
                console.log("Artículo, Formulario completos, FALTAN ITEMS")
                this.formCompleto = false
              }
              break
            case 3:
              console.log(
                "Artículo, Formulario completos, esta categoría no tiene Items"
              )
              this.formCompleto = true
              break
            case 4:
              console.log(
                "Artículo, Formulario completos, esta categoría no tiene Items"
              )
              this.formCompleto = true
              break
            case 5:
              if (
                Object.keys(this.itemsComputo).length > 0 ||
                Object.keys(this.itemsTelefono).length > 0 ||
                Object.keys(this.itemsVehiculo).length > 0
              ) {
                console.log("Artículo, Formulario e items completos")
                this.formCompleto = true
              } else {
                console.log("Artículo, Formulario completos, FALTAN ITEMS")
                this.formCompleto = false
              }
              break

            default:
              break
          }
        } else {
          console.log("Ningún formulario ha sido llenado")
        }
      } else {
        this.formCompleto = false
      }
    },

    obtenerData() {
      switch (this.responsiva_editar.categoria) {
        case 1:
          ResponsivasService.getItems_Computo(this.responsiva_editar.nombre_responsiva)
            .then(data => {
              console.log(data[0])
              this.dataFormComputoBD = this.convertirDataComputo(data[0])
              this.dataFormComputo = this.dataFormComputoBD
              this.itemsComputo = this.dataFormComputoBD
              this.getDataRegistro()
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
          break
        case 2:
          ResponsivasService.getItems_Telefono(this.responsiva_editar.nombre_responsiva)
            .then(data => {
              console.log(data[0])
              this.dataFormTelefonoBD = this.convertirItemTel(data[0])
              this.dataFormTelefono = this.dataFormTelefonoBD 
              this.itemsTelefono = this.dataFormTelefonoBD
              this.getDataRegistro()
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
          break
        case 3:
          ResponsivasService.getItems_Combustible(this.responsiva_editar.nombre_responsiva)
            .then(data => {
              console.log(data[0])
              this.dataFormCombustibleBD = data[0]
              this.dataFormCombustible = this.dataFormCombustibleBD
              this.getDataRegistro()
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
          break
        case 4:
          ResponsivasService.getItems_Peaje(this.responsiva_editar.nombre_responsiva)
            .then(data => {
              console.log(data)
              this.dataFormPeajeBD = data[0]
              this.dataFormPeaje = this.dataFormPeajeBD
              this.getDataRegistro()
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
          break
        case 5:
          ResponsivasService.getItems_Vehiculos(this.responsiva_editar.nombre_responsiva)
            .then(data => {
              console.log(data[0])
              this.dataFormVehiculoBD = this.convetirItemVehiculo(data[0])
              this.dataFormVehiculo = this.dataFormVehiculoBD 
              this.itemsVehiculo = this.dataFormVehiculoBD
              this.getDataRegistro()
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
          break
        default:
          break
      }
      
    },

    getDataRegistro() {
      this.isLoading = false
      this.deshabilitarCheck_items = true
      this.desabilitarForms = true
    },

    convertirDataComputo (data) {
      return {
        ...data,
        accesorios: parseInt(data.accesorios) ==1 ? true : false,
        backpack: parseInt(data.backpack) ==1 ? true : false,
        caja: parseInt(data.caja) ==1 ? true : false,
        cargador: parseInt(data.cargador) ==1 ? true : false,
        funda: parseInt(data.funda) ==1 ? true : false,
        mouse: parseInt(data.mouse) ==1 ? true : false
      }
    },
    
    convertirDataUsuarios (user) {
      return {
        ...user,
        categoria: parseInt(user.categoria),
        departamento: parseInt(user.departamento),
        jefeArea: parseInt(user.jefeArea)
      }
    },

    convetirItemsResponsiva (item) {
      return {
        ...item,
        responsiva: parseInt(item.responsiva),
        estado: parseInt(item.estado),
      }
    },

    displayToast (text, icon, actionText) {
      let toast = this.$toasted.show(text, { 
        theme: "toasted-primary", 
        position: "bottom-right", 
        duration : null,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            toastObject.goAway(0)
          }
        },
      })
    },
    
    getTitleDatosForms () {
      let html = ''
      if (Object.keys(this.dataFormComputo).length > 0 || Object.keys(this.dataFormTelefono).length > 0 || Object.keys(this.dataFormCombustible).length > 0 || Object.keys(this.dataFormPeaje).length > 0 || Object.keys(this.dataFormVehiculo).length > 0) {
        //console.log('Here ✋')
        html = `<span class='tag is-black'>Datos Completos</span>`
        return html
      } else {
        return  html = ''
      }
    },

    getTitleDatosList () {
      let html = ''
      if (Object.keys(this.itemsComputo).length > 0 || Object.keys(this.itemsTelefono).length > 0 || Object.keys(this.itemsVehiculo).length > 0) {
        //console.log('Here 🐥') 
        html = `<span class='tag is-black'>Datos Completos</span>`
        return html
      } else {
        return html = ''
      }
    },
    
    convertirItemTel (item) {
      return {
        ...item,
        cargador: parseInt(item.cargador),
        audifonos: parseInt(item.audifonos),
        caja: parseInt(item.caja),
        sim: parseInt(item.sim),
        protector: parseInt(item.protector),
        adaptador: parseInt(item.adaptadorSd)
      }
    },

    convetirItemVehiculo (item) {
      console.log(item)
      return{
        ...item,
        id: parseInt(item.id),
        antenaRadio: parseInt(item.antena_radio),
        batea: parseInt(item.batea),
        bedliner: parseInt(item.bedliner),
        birlos: parseInt(item.birlos),
        bolsa: parseInt(item.bolsa_herr),
        cablesCor: parseInt(item.cables_corr),
        calaveras: parseInt(item.calaveras),
        cinturonesSeg: parseInt(item.cinturonesSeg),
        controlApert: parseInt(item.control_ape),
        cristales: parseInt(item.cristales),
        defensas: parseInt(item.defensas),
        emblemaD: parseInt(item.emblema_del),
        emblemaT: parseInt(item.emblema_tras),
        encendedor: parseInt(item.encendedor),
        espejoInt: parseInt(item.espejo_int),
        espejoLD: parseInt(item.espejoLD),
        espejoLI: parseInt(item.espejoLI),
        extintor: parseInt(item.extintor),
        faros: parseInt(item.faros),
        gato: parseInt(item.gato),
        hojalateria: parseInt(item.hojalateria),
        limpiadores: parseInt(item.limpiadores),
        llanta: parseInt(item.llanta_refaccion),
        llantas: parseInt(item.llantas),
        llave: parseInt(item.llave),
        llaveCruz: parseInt(item.llave_cruz),
        llaveTaponComb: parseInt(item.llave_tapComb),
        manija: parseInt(item.manija_puerta),
        manual: parseInt(item.manual),
        medallon: parseInt(item.medallon),
        molduras: parseInt(item.molduras),
        motor: parseInt(item.motor),
        parabrisas: parseInt(item.parabrisas),
        pintura: parseInt(item.pintura),
        placaD: parseInt(item.placasF),
        placaT: parseInt(item.placasT),
        poliza: parseInt(item.poliza),
        polizaV: parseInt(item.polizaV),
        portaPD: parseInt(item.porta_placaD),
        portaPT: parseInt(item.porta_placaT),
        radio: parseInt(item.radio_estereo),
        reflejantes: parseInt(item.reflejantes),
        rines: parseInt(item.rines),
        tapetes: parseInt(item.tapetes),
        tapaCBatea: parseInt(item.tapaCubreBatea),
        taponAceite: parseInt(item.tapon_aceite),
        taponGas: parseInt(item.tapon_gasolina),
        taponRadiador: parseInt(item.tapon_radiador),
        taponRueda: parseInt(item.tapon_rueda),
        tarjetaCirc: parseInt(item.tarjeta_circ),
        varillaAceite: parseInt(item.varilla_aceite),
        verificacion: parseInt(item.verificacion),
        vestiduras: parseInt(item.vestiduras),
        viceras: parseInt(item.viceras),
        gasolina: parseInt(item.gasolina),
        motorStr: item.numero_motor,
      }
    },

    updateFormVehiculo (upd) {
      this.updFormVehiculo = true
    },

    convertBoolToInt (val) {
      let result = 0
      if (typeof val === "boolean"){
        result =  val ? 1 : 0
      } else {
        result = val
      }
      return result
    }
  },
  created() {
    this.iniciarComponente()
  },

  computed: {
    ...mapState(["logueado", "userLogin", "responsiva_editar"])
  }
}
</script>

<style lang="css" scoped>
.column-blanco {
  padding-bottom: 100px
}
</style>



// WEBPACK FOOTER //
// src/components/responsivas_Componentes/EditarResponsiva.vue